import { Injectable } from '@angular/core';
import { ColumnModel } from '@shared/models/columns/column-catalog.model';
import { BehaviorSubject, Subject } from 'rxjs';

export interface EditBoxChangeEvent {
  column?: ColumnModel;
  record?: any;
  field?: string;
  value?: any;
  recordId?: any;
}

@Injectable({ providedIn: 'root' })
export class EditingBoxStreamService {
  private _stream = new BehaviorSubject<EditBoxChangeEvent>(null);
  private _addedArrayStream = new Subject<{}>();
  private _deletedArrayStream = new Subject<{}>();
  private _arrayItem = new Subject<any[]>();

  public changeStream$ = this._stream.asObservable();
  public addArrayChangeStream$ = this._addedArrayStream.asObservable();
  public deleteArrayChangeStream$ = this._deletedArrayStream.asObservable();
  public arrayAttributesStream$ = this._arrayItem.asObservable();

  public pushChangeStream($event: EditBoxChangeEvent) {
    this._stream.next($event);
  }

  public addArrayChangeStream(record, $event: any) {
    this._addedArrayStream.next({ record, $event });
  }

  public removeArrayChangeStream($event: any) {
    this._deletedArrayStream.next({ $event });
  }

  public pushArrayAttributesStream($event: any[]) {
    this._arrayItem.next($event);
  }
}
